module.exports = __webpack_public_path__ + "static/media/iconEvaluationActive.6ab222c1.svg";